// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i4UDjbllB5EcxgjhdVaL .ee2hdxdpAvwVVLufOK8I{background:var(--background-primary-inverted-primary);position:-webkit-sticky;position:sticky;bottom:0}.i4UDjbllB5EcxgjhdVaL .gPGLw0DXcJ31fIjqZ8s4{background:var(--background-neutral-subtle);border-radius:8px;flex-direction:column;margin-top:40px;margin-bottom:32px;padding:16px;display:flex}.i4UDjbllB5EcxgjhdVaL .YWI3O93aWDYYMBCn_QaA{margin-bottom:0}.i4UDjbllB5EcxgjhdVaL .vxqqbcMz0ggnJlcwo2lx{background-color:var(--black-20);height:1px;margin-top:4px;margin-bottom:14px}.i4UDjbllB5EcxgjhdVaL .B8HSr3RREUYDSqMiURYT{margin-left:4px}.i4UDjbllB5EcxgjhdVaL .VcGR6A_i5RkY5_MRepLm{padding-top:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderSummary": `i4UDjbllB5EcxgjhdVaL`,
	"stickyActions": `ee2hdxdpAvwVVLufOK8I`,
	"summary": `gPGLw0DXcJ31fIjqZ8s4`,
	"totalSummaryLine": `YWI3O93aWDYYMBCn_QaA`,
	"divider": `vxqqbcMz0ggnJlcwo2lx`,
	"tooltipDate": `B8HSr3RREUYDSqMiURYT`,
	"alert": `VcGR6A_i5RkY5_MRepLm`
};
export default ___CSS_LOADER_EXPORT___;
